import styled from "styled-components";
import ExportButton from "./ExportButton";
import ImportButton from "./ImportButton";

const SaveRow = styled.div`
    text-align: right;
`;

function ImportExport() {
    return (
        <SaveRow>
            <ImportButton />
            <ExportButton />
        </SaveRow>
    );
}

export default ImportExport;
